export default "__VITE_PUBLIC_ASSET__6a718054__"